// extracted by mini-css-extract-plugin
module.exports = {"main":"main___ePPjd","icon":"icon___7wNx0","other":"other___zWt3X","register":"register___UlWZW"};